export default {
  title: 'ExpertOrder',
  form: {
    api_key: {
      label: 'Clave API',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    error: 'Error al guardar los cambios',
    success: 'Los cambios se guardaron',
  },
  connected: {
    title: 'ExpertOrder está conectado',
    description: 'Esta integración está configurada.',
  },
};
